const config = {
  env: process.env.NODE_ENV,
  googleAnalytics: process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_CODE,
  baseURI:
    process.env.NODE_ENV === 'development' ? process.env.REACT_APP_API_BASE_URI : window.location.origin + '/api/',
  googleApplicationKey: process.env.REACT_APP_GOOGLE_APPLICATION_KEY
};

export default config;
